import { stringToArrayFormatterUtil, stringToArrayNumbersFormatterUtil, toDateFormatterUtil, toFloatFormatterUtil } from 'models/formatters/utils'
import { formatInstance } from 'models/formatters'
import { CATEGORY_BEFORE_SAVE_HOOK } from 'models/daos/category/hooks/before-save'
import { PRODUCT_BEFORE_SAVE_HOOK } from 'models/daos/product/hooks/before-save'
import { PROMO_CODE_BEFORE_SAVE_HOOK } from 'models/daos/promo-code/hooks/before-save'
import { USER_BEFORE_SAVE_HOOK } from 'models/daos/user/hooks/before-save'
import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { PRODUCT_MODEL_CLASS_NAME } from 'models/daos/product/constants'
import { PROMO_CODE_MODEL_CLASS_NAME } from 'models/daos/promo-code/constants'
import { USER_MODEL_CLASS_NAME } from 'models/daos/user/constants'

const FORMATTER_MAP = {
  price: toFloatFormatterUtil,
  tags: stringToArrayFormatterUtil,
  categories: stringToArrayFormatterUtil,
  users: stringToArrayNumbersFormatterUtil,
  recommended: stringToArrayNumbersFormatterUtil,
  shipping: toFloatFormatterUtil,
  subTotal: toFloatFormatterUtil,
  tax: toFloatFormatterUtil,
  total: toFloatFormatterUtil,
  weight: toFloatFormatterUtil,
  height: toFloatFormatterUtil,
  publishedAt: toDateFormatterUtil,
  featuredAt: toDateFormatterUtil,
  limitedAt: toDateFormatterUtil
}

const CLASS_NAME_TO_FORMATTER = {
  [CATEGORY_MODEL_CLASS_NAME]: CATEGORY_BEFORE_SAVE_HOOK,
  [PRODUCT_MODEL_CLASS_NAME]: PRODUCT_BEFORE_SAVE_HOOK,
  [PROMO_CODE_MODEL_CLASS_NAME]: PROMO_CODE_BEFORE_SAVE_HOOK,
  [USER_MODEL_CLASS_NAME]: USER_BEFORE_SAVE_HOOK
}

function formatInstanceBeforeSave (params = {}) {
  const { className } = params
  const formatterMap = {
    ...FORMATTER_MAP,
    ...(CLASS_NAME_TO_FORMATTER[className] || {})
  }
  return formatInstance({
    ...params,
    formatterMap
  })
}

export {
  formatInstanceBeforeSave
}
